/* eslint-disable max-len */
import React from 'react';


const TumblrIcon = (props) => (
  <svg
    {...props}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="256" cy="256" fill="#fff" r="240" />
    <path d="M256,0C114.612,0,0,114.612,0,256c0,141.388,114.612,256,256,256c141.388,0,256-114.612,256-256  C512,114.612,397.388,0,256,0z M345.469,380.469c-12.419,5.844-23.656,9.956-33.719,12.312c-10.05,2.355-20.938,3.531-32.639,3.531  c-13.269,0-24.999-1.676-35.205-5.031c-10.207-3.356-18.906-8.145-26.105-14.332c-7.227-6.213-12.226-12.812-14.988-19.812  c-2.8-6.979-4.176-17.123-4.176-30.387V224.874h-32.105v-41.112c11.406-3.7,21.188-9.012,29.312-15.937  c8.144-6.919,14.669-15.25,19.594-24.951c4.925-9.688,8.312-22.031,10.156-37.012h41.312v73.406h68.919v45.605h-68.919v74.47  c0,16.845,0.906,27.656,2.688,32.438c1.77,4.781,5.106,8.594,9.956,11.455c6.419,3.839,13.763,5.775,22.044,5.775  c14.688,0,29.331-4.775,43.875-14.338V380.469z" fill="#001935" />
  </svg>
);

export default TumblrIcon;
